// Bump TERMS_VERSION when the legal text changes; users will be required
// to re-accept on next login. TERMS_DATE is shown in the AGB header.
export const TERMS_VERSION = 1
export const TERMS_DATE = '2026-05-01'

const STORAGE_KEY = 'tt-terms-accepted'

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
  } catch (e) {
    return {}
  }
}

export function isTermsAccepted(email) {
  if (!email) return false
  const entry = readAll()[email.toLowerCase()]
  return !!entry && entry.version === TERMS_VERSION
}

export function markTermsAccepted(email) {
  if (!email) return
  const all = readAll()
  all[email.toLowerCase()] = {
    version: TERMS_VERSION,
    acceptedAt: new Date().toISOString()
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all))
  } catch (e) {
    // Storage full / disabled — ignore; user will be asked again next time.
  }
}